import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { WidgetID, WidgetViewToggleModel } from '../../models/widget.model';

// identifier
export const VIEW_TOGGLE_SLICE = 'viewToggle';

// default state
const initialState: WidgetViewToggleModel = {
  toggles: {},
};

//slice
const viewSlice = createSlice({
  name: VIEW_TOGGLE_SLICE,
  initialState,
  reducers: {
    toggleView: (
      state: WidgetViewToggleModel,
      action: PayloadAction<{ id: WidgetID; view: number }>
    ): void => {
      //state.query = action.payload;
      if (!state.toggles[action.payload.id]) {
        state.toggles[action.payload.id] = 0;
      }
      state.toggles[action.payload.id] = action.payload.view;
    },
  },
});

//selectors
export const selectViewStateForWidget = (state: RootState) => state.viewToggle.toggles;

export const selectViewStateForWidgetById = (state: RootState, id: WidgetID): number | undefined =>
  state.viewToggle.toggles[id];

//actions
export const { toggleView } = viewSlice.actions;

//reducer
export default viewSlice;
